import { render } from "./Specialty.vue?vue&type=template&id=d477d10a"
import script from "./Specialty.vue?vue&type=script&lang=js"
export * from "./Specialty.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__